import React from 'react';
import {
  ProgramContainer,
  ProgramCardWrapper,
  ProgramIcon,
  ProgramCard,
  ProgramH2,
  BtnLink1,
} from './ProgramElements';

const UIIISection = () => {
  return (
    <ProgramContainer>
      <ProgramCardWrapper>
        <ProgramIcon src={`/program/Mengapa DPLKS Muamalat.png`} />
        <ProgramCard>
          <BtnLink1 href="https://www.dplksyariahmuamalat.co.id/peserta/registrasi/"><strong>Daftar Sekarang*</strong></BtnLink1>
          <ProgramH2>
            *Masukkan kode <strong>UIII-[NIK/Nomor Induk Karyawan]</strong><br/>
            pada kolom <strong>Nomor Referensi</strong> saat melakukan pendaftaran<br/>
            Contoh: UIII-12345
          </ProgramH2>
        </ProgramCard>
      </ProgramCardWrapper>
    </ProgramContainer>
  );
};

export default UIIISection;
